import AddDevice from "./AddDevice/AddDevice";
import ViewDevice from "./ViewDevice/ViewDevice";
import LinkDevice from "./LinkDevice/LinkDevice";
import {
  useNewDevice,
  useDissociateFromPatient,
  usePutDeviceById,
  useGetDeviceById,
  useGetDevices,
  useGetPatientDevices,
} from "./useDeviceQueries";

// const devices = [
//   { category: "Multiparametro", label: "butterflife", id: 1 },
//   { category: "ECG", label: "butterflife", id: 1 },
//   { category: "Pressione", label: "pressure", id: 2 },
//   { category: "Ossimetria", label: "O2ring_viatom", id: 3 },
//   { category: "Temperatura", label: "termometro_viatom", id: 4 },
// ];

const deviceCategories = [
  "multiparametro",
  "ossimetria",
  "ECG",
  "temperatura",
  "pressione",
];

const devices = [
  {
    h3k_code: "H3K007/A",
    device_type: 1,
    name: "butterflife grande",
    category: "multiparametro",
  },
  {
    h3k_code: "H3K0028",
    device_type: 2,
    name: "linktop 6 in 1",
    category: "multiparametro",
  },
  {
    h3k_code: "H3K0013",
    device_type: 3,
    name: "viatom O2Ring",
    category: "ossimetria",
  },
  {
    h3k_code: "H3K0017",
    device_type: 4,
    name: "viatom termometro AOJ-20AAOJ-20A",
    category: "temperatura",
  },
  {
    h3k_code: "H3K0022",
    device_type: 5,
    name: "viatom BP2 armfit +",
    category: "multiparametro",
  },
  {
    h3k_code: "H3K007/B",
    device_type: 6,
    name: "butterflife mini",
    category: "multiparametro",
  },
  {
    h3k_code: "H3K0031",
    device_type: 7,
    name: "viatom check me O2Max",
    category: "ossimetria",
  },
  // { h3k_code: "H3K0002", device_type: 8, name: "VIATOM DuoEK", category: "" },
  // {
  //   h3k_code: "H3K0010",
  //   device_type: 9,
  //   name: "GIMA PC_300SNT",
  //   category: "",
  // },
  // {
  //   h3k_code: "H3K0020",
  //   device_type: 10,
  //   name: "Bilancia OMNRON Viva",
  //   category: "",
  // },
  {
    h3k_code: "H3K0009",
    device_type: 11,
    name: "VIATOM Check me Pro",
    category: "multiparametro",
  },
  // {
  //   h3k_code: "H3K0028/1",
  //   device_type: 12,
  //   name: "LINKTOP Digital Otoscope",
  //   category: "",
  // },
  // {
  //   h3k_code: "H3K0028/2",
  //   device_type: 13,
  //   name: "LINKTOP Digital Stethscope",
  //   category: "",
  // },
  // {
  //   h3k_code: "H3K0028/3",
  //   device_type: 14,
  //   name: "LINKTOP Nex Ring",
  //   category: "",
  // },
  // {
  //   h3k_code: "H3K0018",
  //   device_type: 15,
  //   name: "Easy Temp NFC",
  //   category: "",
  // },
  // {
  //   h3k_code: "H3K0025",
  //   device_type: 16,
  //   name: "ABBOTT Freestyle Libre",
  //   category: "",
  // },
  // {
  //   h3k_code: "H3K0011",
  //   device_type: 17,
  //   name: "ABBOTT Freestyle Libre Freedom Lite",
  //   category: "",
  // },
  // {
  //   h3k_code: "H3K0011/1",
  //   device_type: 18,
  //   name: "ABBOTT Freestyle Lite Glicimia",
  //   category: "",
  // },
  // {
  //   h3k_code: "H3K0005",
  //   device_type: 19,
  //   name: "OMRON Evolv Pressione Arteriosa",
  //   category: "",
  // },
  // {
  //   h3k_code: "H3K0006",
  //   device_type: 20,
  //   name: "OMRON RS3 Intelli IT Pressione (da polso)",
  //   category: "",
  // },
];

export {
  AddDevice,
  ViewDevice,
  LinkDevice,
  useNewDevice,
  useDissociateFromPatient,
  usePutDeviceById,
  useGetDeviceById,
  deviceCategories,
  useGetDevices,
  useGetPatientDevices,
  devices,
};
